import React from 'react'
import { Text, TextProps } from 'rebass/styled-components'

export const SmartSelectHeading = ({ children, sx, ...props }: TextProps): JSX.Element => {
  return (
    <Text
      data-name="SmartSelectHeading"
      as="h3"
      sx={{
        fontSize: 0,
        fontWeight: '700',
        color: 'light-dark(var(--brand-grey-400),var(--brand-grey-200))',
        p: '0 20px 15px 20px',
        ...sx
      }}
      {...props}
    >
      {children}
    </Text>
  )
}
